import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import { useHistory, useLocation } from 'react-router-dom';
import { A, CONTACT_NUMBER, H1, P, TDD_TTY_NUMBER, WIZARD_URL } from 'shared';
import PreQualificationDeclinedAdsOnlyLanguage from '../components/PreQualificationDeclinedAdsOnlyLanguage';
function PreQualificationDeclinedAdsOnlyPage() {
    const history = useHistory();
    const redirectToWizard = () => {
        history.push({
            pathname: WIZARD_URL,
            state: {
                step: 'PRE-QUALIFICATION',
                fullApp: true,
            },
        });
    };
    const location = useLocation();
    const lenderStatusMessage = location?.state?.lenderStatusMessage;
    return (_jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content", children: [_jsx(H1, { className: "first-title", children: "Pre-qualification" }), _jsx(P, { className: "first-subtitle", variant: "title-large", bold: true, children: "Thank you for your interest in the Alphaeon Credit Card." }), _jsx(P, { bold: true, children: _jsx(PreQualificationDeclinedAdsOnlyLanguage, { lenderStatusMessage: lenderStatusMessage, redirectToWizard: () => redirectToWizard() }) }), _jsxs("div", { className: "info-container", children: [_jsx(LocalPhoneIcon, {}), ' ', _jsxs("div", { className: "number-container", children: [_jsx("div", { children: _jsx(A, { href: `tel:${CONTACT_NUMBER}`, variant: "title-large", underline: false, children: CONTACT_NUMBER }) }), ' ', _jsx("div", { children: _jsxs(A, { href: `tel:${TDD_TTY_NUMBER}`, variant: "title-large", underline: false, children: ["(TDD/TTY ", TDD_TTY_NUMBER, ")"] }) })] })] })] }) }));
}
export default PreQualificationDeclinedAdsOnlyPage;
